import { createContext } from 'react';

import type { HttpProviderContext } from './useHttpProvider';

export const HttpContext = createContext({} as HttpProviderContext);
